// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/retention/public/v1/rewards.proto (package gdx.retention.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum gdx.retention.public.v1.PromotionType
 */
export enum PromotionType {
  /**
   * @generated from enum value: PROMOTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMOTION_TYPE_SEVEN_DAYS = 1;
   */
  SEVEN_DAYS = 1,

  /**
   * @generated from enum value: PROMOTION_TYPE_PHOTO_UPLOAD = 2;
   */
  PHOTO_UPLOAD = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PromotionType)
proto3.util.setEnumType(PromotionType, "gdx.retention.public.v1.PromotionType", [
  { no: 0, name: "PROMOTION_TYPE_UNSPECIFIED" },
  { no: 1, name: "PROMOTION_TYPE_SEVEN_DAYS" },
  { no: 2, name: "PROMOTION_TYPE_PHOTO_UPLOAD" },
]);

/**
 * @generated from enum gdx.retention.public.v1.StageUnit
 */
export enum StageUnit {
  /**
   * @generated from enum value: STAGE_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STAGE_UNIT_DAY = 1;
   */
  DAY = 1,

  /**
   * @generated from enum value: STAGE_UNIT_COUNT = 2;
   */
  COUNT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(StageUnit)
proto3.util.setEnumType(StageUnit, "gdx.retention.public.v1.StageUnit", [
  { no: 0, name: "STAGE_UNIT_UNSPECIFIED" },
  { no: 1, name: "STAGE_UNIT_DAY" },
  { no: 2, name: "STAGE_UNIT_COUNT" },
]);

/**
 * @generated from enum gdx.retention.public.v1.RewardType
 */
export enum RewardType {
  /**
   * @generated from enum value: REWARD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REWARD_TYPE_DAILY_FREE_GIFT = 1;
   */
  DAILY_FREE_GIFT = 1,

  /**
   * @generated from enum value: REWARD_TYPE_FREE_GIFT = 2;
   */
  FREE_GIFT = 2,

  /**
   * @generated from enum value: REWARD_TYPE_ASTROLOGICAL_COMPATIBILITY = 3;
   */
  ASTROLOGICAL_COMPATIBILITY = 3,

  /**
   * @generated from enum value: REWARD_TYPE_SEXUAL_COMPATIBILITY = 4;
   */
  SEXUAL_COMPATIBILITY = 4,

  /**
   * @generated from enum value: REWARD_TYPE_CREDITS = 5;
   */
  CREDITS = 5,

  /**
   * @generated from enum value: REWARD_TYPE_TOP_PROFILE = 6;
   */
  TOP_PROFILE = 6,

  /**
   * @generated from enum value: REWARD_TYPE_POWER_LIKE = 7;
   */
  POWER_LIKE = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(RewardType)
proto3.util.setEnumType(RewardType, "gdx.retention.public.v1.RewardType", [
  { no: 0, name: "REWARD_TYPE_UNSPECIFIED" },
  { no: 1, name: "REWARD_TYPE_DAILY_FREE_GIFT" },
  { no: 2, name: "REWARD_TYPE_FREE_GIFT" },
  { no: 3, name: "REWARD_TYPE_ASTROLOGICAL_COMPATIBILITY" },
  { no: 4, name: "REWARD_TYPE_SEXUAL_COMPATIBILITY" },
  { no: 5, name: "REWARD_TYPE_CREDITS" },
  { no: 6, name: "REWARD_TYPE_TOP_PROFILE" },
  { no: 7, name: "REWARD_TYPE_POWER_LIKE" },
]);

/**
 * @generated from enum gdx.retention.public.v1.StageState
 */
export enum StageState {
  /**
   * @generated from enum value: STAGE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STAGE_STATE_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: STAGE_STATE_SCHEDULED = 2;
   */
  SCHEDULED = 2,

  /**
   * @generated from enum value: STAGE_STATE_EXPIRED = 3;
   */
  EXPIRED = 3,

  /**
   * @generated from enum value: STAGE_STATE_CLAIMED = 4;
   */
  CLAIMED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(StageState)
proto3.util.setEnumType(StageState, "gdx.retention.public.v1.StageState", [
  { no: 0, name: "STAGE_STATE_UNSPECIFIED" },
  { no: 1, name: "STAGE_STATE_AVAILABLE" },
  { no: 2, name: "STAGE_STATE_SCHEDULED" },
  { no: 3, name: "STAGE_STATE_EXPIRED" },
  { no: 4, name: "STAGE_STATE_CLAIMED" },
]);

/**
 * @generated from message gdx.retention.public.v1.Promotion
 */
export class Promotion extends Message<Promotion> {
  /**
   * @generated from field: gdx.retention.public.v1.PromotionType type = 1;
   */
  type = PromotionType.UNSPECIFIED;

  /**
   * @generated from field: bool auto_claim = 2;
   */
  autoClaim = false;

  /**
   * @generated from field: repeated gdx.retention.public.v1.Stage stages = 3;
   */
  stages: Stage[] = [];

  constructor(data?: PartialMessage<Promotion>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.retention.public.v1.Promotion";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PromotionType) },
    { no: 2, name: "auto_claim", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "stages", kind: "message", T: Stage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Promotion {
    return new Promotion().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Promotion {
    return new Promotion().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Promotion {
    return new Promotion().fromJsonString(jsonString, options);
  }

  static equals(a: Promotion | PlainMessage<Promotion> | undefined, b: Promotion | PlainMessage<Promotion> | undefined): boolean {
    return proto3.util.equals(Promotion, a, b);
  }
}

/**
 * @generated from message gdx.retention.public.v1.Stage
 */
export class Stage extends Message<Stage> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: gdx.retention.public.v1.StageState state = 2;
   */
  state = StageState.UNSPECIFIED;

  /**
   * @generated from field: gdx.retention.public.v1.StageUnit unit = 3;
   */
  unit = StageUnit.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp expires_time = 4;
   */
  expiresTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 5;
   */
  expiresDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp available_after_time = 6;
   */
  availableAfterTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration available_after_duration = 7;
   */
  availableAfterDuration?: Duration;

  /**
   * @generated from field: repeated gdx.retention.public.v1.Reward rewards = 8;
   */
  rewards: Reward[] = [];

  constructor(data?: PartialMessage<Stage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.retention.public.v1.Stage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(StageState) },
    { no: 3, name: "unit", kind: "enum", T: proto3.getEnumType(StageUnit) },
    { no: 4, name: "expires_time", kind: "message", T: Timestamp },
    { no: 5, name: "expires_duration", kind: "message", T: Duration },
    { no: 6, name: "available_after_time", kind: "message", T: Timestamp },
    { no: 7, name: "available_after_duration", kind: "message", T: Duration },
    { no: 8, name: "rewards", kind: "message", T: Reward, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Stage {
    return new Stage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Stage {
    return new Stage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Stage {
    return new Stage().fromJsonString(jsonString, options);
  }

  static equals(a: Stage | PlainMessage<Stage> | undefined, b: Stage | PlainMessage<Stage> | undefined): boolean {
    return proto3.util.equals(Stage, a, b);
  }
}

/**
 * @generated from message gdx.retention.public.v1.Reward
 */
export class Reward extends Message<Reward> {
  /**
   * @generated from field: gdx.retention.public.v1.RewardType type = 1;
   */
  type = RewardType.UNSPECIFIED;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity = 0;

  constructor(data?: PartialMessage<Reward>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.retention.public.v1.Reward";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(RewardType) },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Reward {
    return new Reward().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Reward {
    return new Reward().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Reward {
    return new Reward().fromJsonString(jsonString, options);
  }

  static equals(a: Reward | PlainMessage<Reward> | undefined, b: Reward | PlainMessage<Reward> | undefined): boolean {
    return proto3.util.equals(Reward, a, b);
  }
}

